var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileLoaderClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0,0H14V14H0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    id: "path_file_icon",
    d: "M8.227.236,4.8,3.661,1.378.236A.807.807,0,0,0,.236,1.378L3.661,4.8.236,8.227A.807.807,0,0,0,1.378,9.368L4.8,5.944,8.227,9.368A.807.807,0,0,0,9.368,8.227L5.944,4.8,9.368,1.378A.807.807,0,0,0,8.227.236Z",
    transform: "translate(11.604 2) rotate(90)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileLoaderClose);
export default __webpack_public_path__ + "static/media/file-loader-close.b045c4151d864348ec780b262386bd7e.svg";
export { ForwardRef as ReactComponent };